import HallowButton from "../../components/customComponents/HallowButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import CompanyInformationModal from "../../components/Modal/CompanyInformationModal";
import { setCompanyInformationModal } from "../../reducer/modalReducer";
import { useEffect, useState } from "react";

export default function RegistrationCompanyInformationSection() {
  const dispatch = useDispatch();
  const {
    legalStatus,
    companyLogo,
    legalIndividualName,
    publicCompanyName,
    companyDescription,
    website,
    onlineContactInfo,
  } = useSelector((state: RootState) => state.registration);

  const profile = useSelector((state: RootState) => state.profile.profile);

  const [editedLegalStatus, setEditedLegalStatus] = useState(
    profile?.legalStatus || legalStatus || ""
  );
  const [editedCompanyLogo, setEditedCompanyLogo] = useState<string | null>(
    profile?.logo instanceof File
      ? URL.createObjectURL(profile.logo)
      : profile?.logo || companyLogo || ""
  );
  const [editedLegalIndividualName, setEditedLegalIndividualName] = useState(
    profile?.legalCompanyName ||
      profile?.legalIndividualName ||
      legalIndividualName ||
      ""
  );
  const [editedPublicCompanyName, setEditedPublicCompanyName] = useState(
    profile?.publicCompanyName || publicCompanyName || ""
  );
  const [editedCompanyDescription, setEditedCompanyDescription] = useState(
    profile?.companyDescription || companyDescription || ""
  );
  const [editedWebsite, setEditedWebsite] = useState(
    profile?.website || website || ""
  );

  useEffect(() => {
    if (profile) {
      setEditedLegalStatus(profile.type || legalStatus);
      setEditedLegalIndividualName(
        profile?.legalCompanyName ||
          profile?.legalIndividualName ||
          legalIndividualName
      );
      setEditedPublicCompanyName(
        profile.publicCompanyName || publicCompanyName
      );
      setEditedCompanyDescription(
        profile.companyDescription || companyDescription
      );
      setEditedWebsite(profile.website || website);
      setEditedCompanyLogo(
        profile.logo instanceof File
          ? URL.createObjectURL(profile.logo)
          : profile.logo || companyLogo
      );
    }

    console.log("profile data in registration", profile);
  }, [profile, legalStatus]);

  const handleEditButtonClick = () => {
    dispatch(setCompanyInformationModal(true));
  };

  return (
    <div className={Classname.container}>
      <CompanyInformationModal />
      <div className={Classname.flexBetween}>
        <div>
          <div className="font-semibold mb-3">Company Information</div>
          <div>
            The company details that allow customers to recognise your business
            as a legal commercial entity. These will be visible to customers on
            your Intraverse profile page.
          </div>
        </div>
        <HallowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Legal Status</div>
        {editedLegalStatus ? (
          <div>{editedLegalStatus}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Company logo</div>
        <div>
          <div>
            {editedCompanyLogo ? (
              <img
                src={editedCompanyLogo}
                alt="Company Logo"
                className={Classname.companyLogo}
              />
            ) : (
              <img src="/imageplaceholder.png" alt="Placeholder" />
            )}
          </div>
          <div className="text-sm text-gray-500">
            *.png, *.jpg files up to 4MB at least 180px x 180px
          </div>
        </div>
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>
          Legal {editedLegalStatus === "individual" ? "individual" : "company"}{" "}
          name
        </div>
        {editedLegalIndividualName ? (
          <div>{editedLegalIndividualName}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Public company name</div>
        {editedPublicCompanyName ? (
          <div>{editedPublicCompanyName}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Company description</div>
        {editedCompanyDescription ? (
          <div className="flex flex-1">{editedCompanyDescription}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Website and social media</div>
        <div>{editedWebsite}</div>
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white rounded-md p-2 h-fit gap-3 flex flex-col pb-10 lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold lg:w-48 mb-4 lg:mb-0",
  listContainer: "flex lg:gap-40 flex-col lg:flex-row mb-4",
  companyLogo: "w-40 h-20 rounded-md object-contain",
  unspecified: "text-red-500 ",
};
